import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ZendeskAllArticles from '../../../components/tools/zendesk/ZendeskAllArticles/ZendeskAllArticles';
import * as ZendeskActions from '../../../actions/tools/ZendeskActions';
import {
  extractSelectedTicketBusinessDetailsFromState,
  extractSelectedTicketFromState,
} from '../../../extractFromState';

function mapStateToProps(state) {
  const ticket = extractSelectedTicketFromState(state);
  const business = extractSelectedTicketBusinessDetailsFromState(state);

  return {
    zendesk: Object.assign({}, state.tools && state.tools.zendesk),
    selectedToolDomains: Object.assign({}, state.tools.general.selectedToolDomains),
    knowledgeBaseFolderUrl: business && business.knowledgeBaseFolderUrl,
    simplrAccountId: ticket && ticket.simplrAccountPtrId,
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      ...ZendeskActions,
    },
    dispatch
  );
};

const ZendeskAllArticlesContainer = connect(mapStateToProps, mapDispatchToProps)(ZendeskAllArticles);

export default ZendeskAllArticlesContainer;
